<script lang="ts">
	import { marginsWithoutPositions } from '../../userInteract/store';
	import {
		addErrorNotification,
		addTransactionNotification
	} from '$lib/notifications/notificationManager';
	import { getParsedError } from '$lib/web3/errorHandling';
	import { smartContractWalletAddress } from '../store';
	import { executeWithdrawAllUnusedMargins } from '$lib/web3/actions/margin';
	import { updateData } from '../../userInteract/userInteract';
	const withdrawAllMargins = async () => {
		try {
			const tx = await executeWithdrawAllUnusedMargins(
				$marginsWithoutPositions,
				$smartContractWalletAddress as `0x${string}`
			);

			addTransactionNotification('Transaction Confirmed', 'Withdraw all unused margins', tx, () => {
				updateData();
			});
		} catch (e: any) {
			const { title, description } = getParsedError(e);
			addErrorNotification(title, description, JSON.stringify(e));
		}
	};
</script>

{#if $marginsWithoutPositions && $marginsWithoutPositions.length > 0}
	<button
		class="text-xs text-fx-pink font-semibold cursor-pointer"
		on:click={withdrawAllMargins}
		on:keydown={withdrawAllMargins}
	>
		Withdraw all unused margins
	</button>
{/if}
